import {IconButton} from '@material-ui/core';
import {
  AddCircle,
  Assessment,
  HighlightOff,
  Person,
  Print,
} from '@material-ui/icons';
import React, {forwardRef} from 'react';
import {useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';
import {i18n2} from '../../../features/i18n/i18n';
import {print} from '../../../helpers/functions';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {useActionButtonStyles} from 'components/grid-dx/styles/actionButtonStyles';

interface GoToDetailProps {
  data: any;
  url: string;
  id: number;
}

interface SignatureRegistryProps {
  cwid: string;
  employee_Nr: number;
  token: string;
}

interface CapaInitReportProps {
  cwid: string;
  employee_Nr: number;
  token: string;
  capa_Initial: boolean;
}

interface AddProps {
  type: string;
  row: any;
}

interface RemoveProps {
  type: string;
  row: any;
}

export const GoToDetail = ({data, id, url}: GoToDetailProps) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  const LinkBehavior = forwardRef((props: any, ref) => (
    <Link
      ref={ref}
      to={{
        pathname: url,
        state: {data: data, key: id},
      }}
      {...props}
    />
  ));

  return (
    <IconButton
      size="small"
      color={'primary'}
      style={{color: '#4040a1'}}
      title={i18n2._('Ir al detalle')}
      component={LinkBehavior}
      className={isTablet ? styles.tabletButton : styles.compactButton}>
      <Assessment
        className={isTablet ? styles.tabletIcon : styles.compactButton}
      />
    </IconButton>
  );
};

export const SignatureRegistry = ({
  cwid,
  employee_Nr,
  token,
}: SignatureRegistryProps) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  const signatureRegistry = `api/Collaborator/GetSignatureRegistry?employee_Nr=${employee_Nr}`;
  return (
    <IconButton
      size="small"
      title={i18n2._('Registro de firma')}
      className={isTablet ? styles.tabletButton : styles.compactButton}
      onClick={() =>
        print(signatureRegistry, cwid, token, 'signatureRegistry.pdf')
      }>
      <Person className={isTablet ? styles.tabletIcon : styles.compactButton} />
    </IconButton>
  );
};

export const CapaInitReport = ({
  cwid,
  employee_Nr,
  token,
  capa_Initial,
}: CapaInitReportProps) => {
  const capaInitReport = `api/report/GetCapaInitReport?id=${employee_Nr}`;
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div>
      {capa_Initial && (
        <IconButton
          size="small"
          title={i18n2._('Reporte - capacitación inicial')}
          className={isTablet ? styles.tabletButton : styles.compactButton}
          onClick={() =>
            print(capaInitReport, cwid, token, 'CapacitacionInicial.pdf')
          }>
          <Print
            className={isTablet ? styles.tabletIcon : styles.compactButton}
          />
        </IconButton>
      )}
    </div>
  );
};

export const Add = ({row, type}: AddProps) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  const dispatch = useDispatch();

  const add = () => {
    dispatch({type: type, payload: row});
  };

  return (
    <IconButton
      size="small"
      color={'primary'}
      title={i18n2._('Add')}
      className={isTablet ? styles.tabletButton : styles.compactButton}
      onClick={add}>
      <AddCircle
        className={isTablet ? styles.tabletIcon : styles.compactButton}
      />
    </IconButton>
  );
};

export const Remove = ({type, row}: RemoveProps) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  const dispatch = useDispatch();

  const remove = () => {
    dispatch({type: type, payload: row});
  };

  return (
    <IconButton
      size="small"
      color={'secondary'}
      title={i18n2._('Remove')}
      onClick={remove}
      className={isTablet ? styles.tabletButton : styles.compactButton}>
      <HighlightOff
        className={isTablet ? styles.tabletIcon : styles.compactButton}
      />
    </IconButton>
  );
};
